import { CURRENCY_I18N_MAP } from '@/constants/country-code'
import useWorkspaceCurrency from '@/hooks/use-workspace-currency'
import { useIntl } from '@/i18n/hooks/use-intl'

const useLocalizedKolQuotationCurrency = (): string => {
  const { formatMessage } = useIntl()

  const quotationCurrency = useWorkspaceCurrency()

  return formatMessage(
    { id: 'general:displaying_currency' },
    {
      currencyTitle: formatMessage({
        id: CURRENCY_I18N_MAP[quotationCurrency],
      }),
      currencyCode: quotationCurrency,
    },
  )
}

export default useLocalizedKolQuotationCurrency
